import React from 'react'
import Toolbar from './Toolbar'

export const renderToolbar = (renderedParts) => <Toolbar renderedParts={renderedParts} />
